import React, { useEffect, useState } from 'react'
import { LinkButton } from '@zera-admin/button'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import Lozenge from '@zera-admin/lozenge'
import Page, { PageHeader } from '@zera-admin/page'
import Table from '@zera-admin/table'

import Pager from 'components/pager'
import MainLayout from 'layouts/main'
import { GenderTypeEnum } from 'services/http/dataset'
import genderControlSetsService, {
  GenderControlSet,
  GenderControlSetResponse,
} from 'services/http/dataset/gender-control-set'

import { GenderControlSetListProps } from './types'

const GenderControlSetList: React.FunctionComponent<
  GenderControlSetListProps
> = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [genderControlSet, setGenderControlSet] =
    useState<GenderControlSetResponse>()

  useEffect(() => {
    getGenderControlSets()
  }, [])

  const getGenderControlSets = async () => {
    try {
      const response = await genderControlSetsService.get()

      setGenderControlSet(response.data)
      setIsLoading(false)
    } catch (err) {
      console.log(err)
    }
  }

  const renderPageHeader = () => {
    const actions = (
      <LinkButton appearance="primary" href="/gender-control-set/create">
        Cinsiyet kontrol seti oluştur
      </LinkButton>
    )

    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Cinsiyet kontrol setleri" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>
        Tüm cinsiyet kontrol setlerini görüntüleyebilir, yeni oluşturabilir,
        varolanları düzenleyebilirsiniz.
      </p>
    )

    return (
      <PageHeader
        actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        Cinsiyet kontrol setleri
      </PageHeader>
    )
  }

  const renderPageTable = () => {
    const columns = [
      {
        name: 'text',
        text: 'Cinsiyet kontrol seti metni',
      },
      {
        name: 'languageCode',
        text: 'Dil kodu',
      },
      {
        name: 'conclusion',
        text: 'Cinsiyet',
        render: (props: GenderControlSet) => {
          if (props.conclusion === GenderTypeEnum.Female) {
            return <Lozenge appearance="info">Erkek</Lozenge>
          } else if (props.conclusion === GenderTypeEnum.Male) {
            return <Lozenge appearance="error">Kadın</Lozenge>
          } else {
            return <Lozenge appearance="default">Belirtilmemiş</Lozenge>
          }
        },
      },
      {
        name: 'operation',
        text: 'İşlemler ',
        width: '100px',
        render: (item: GenderControlSet) => (
          <LinkButton
            appearance="subtle-link"
            href={`/gender-control-set/update/${item.id}`}
          >
            Görüntüle
          </LinkButton>
        ),
      },
    ]

    if (genderControlSet) {
      return (
        <React.Fragment>
          <Table
            columns={columns as any}
            rows={genderControlSet.list}
            isLoading={isLoading}
            helperMessage="Aradığınız kriterlere uygun bir veri bulunamadı"
          />
          <Pager pages={genderControlSet.pageCount} />
        </React.Fragment>
      )
    }

    return null
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderPageTable()}
      </Page>
    </MainLayout>
  )
}

export default GenderControlSetList
